import React, { useState, useEffect } from 'react';
import Title from '../layouts/Title';
import Education from './Education';
import Skills from './Skills';
import Experience from "./Experience";
import Accordion from '../../common/UI/Accordion/Accordion';
import { useTranslation } from 'react-i18next';
import { FaCode } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { IoSchool } from "react-icons/io5";

const Resume = () => {
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState('skills');

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const accordionItems = [
    {
      id: 'skills',
      icon: <FaCode className={`w-5 h-5 ${i18n.language === 'ar' ? 'ml-2' : 'mr-2'}`} />,
      nameKey: "resume.skills.title",
      component: <Skills />
    },
    {
      id: 'experience',
      icon: <MdWork className={`w-5 h-5 ${i18n.language === 'ar' ? 'ml-2' : 'mr-2'}`} />,
      nameKey: "resume.experience.title",
      component: <Experience />
    },
    {
      id: 'education',
      icon: <IoSchool className={`w-5 h-5 ${i18n.language === 'ar' ? 'ml-2' : 'mr-2'}`} />,
      nameKey: "resume.education.title",
      component: <Education />
    }
  ];

  return (
    <section className={`w-full py-20 border-b-[1px] border-b-black ${i18n.language === 'ar' ? "ar-dir" : "en-dir"}`}>
      <div className="flex justify-center items-center text-center">
        <Title title={`${t("resume.feature")}`} des={`${t("resume.title")}`} />
      </div>

      {isMobile ? (
        <Accordion items={accordionItems} />
      ) : (
        <>
          <div className="w-full flex gap-5 mb-10 justify-center">
            {accordionItems.map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`resumeLi ${activeTab === item.id ? "border-designColor rounded-lg" : "border-transparent"}`}
              >
                {t(`${item.nameKey}`)}
              </button>
            ))}
          </div>
          {activeTab === 'skills' && <Skills />}
          {activeTab === 'experience' && <Experience />}
          {activeTab === 'education' && <Education />}
        </>
      )}
    </section>
  );
};

export default Resume;